import { c as _c } from "react/compiler-runtime";
import { NeutralButton } from '@systemeio/ui';
import RuleSave from 'modules/automation-rules/components/rule-save';
import { useAutomationRule } from 'modules/automation-rules/hooks/use-automation-rule';
import { useRuleState } from 'modules/automation-rules/hooks/use-rule-state';
import { SpecificTriggerRulesProps } from 'modules/automation-rules/specific-trigger-rules';
import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { AutomationRuleApiInterface, AutomationRuleViewInterface } from 'modules/automation-rules/types/automation-rule-interface';
import { useEffect, useRef, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { KeyedMutator } from 'swr';
import { SpecificTriggerRule } from './specific-trigger-rule';
import { ArrowIonicLeftIcon } from '@systemeio/ui/icons';
interface SpecificTriggerRuleEditProps extends Pick<SpecificTriggerRulesProps, 'getRelatedAndUnrelatedTriggersData' | 'customAddTriggerHandler' | 'noRelatedMessage'> {
  ruleId: number;
  clearSelectedRule: () => void;
  availableTriggers?: AutomationRuleTriggersEnum[];
  mutateRules: KeyedMutator<AutomationRuleApiInterface>;
  mutateAvailableTriggers: KeyedMutator<AutomationRuleTriggersEnum[]>;
}
const SpecificTriggerRuleEdit = t0 => {
  const $ = _c(42);
  const {
    ruleId,
    clearSelectedRule,
    mutateRules,
    mutateAvailableTriggers,
    availableTriggers,
    getRelatedAndUnrelatedTriggersData,
    customAddTriggerHandler,
    noRelatedMessage
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    data: rule,
    mutate
  } = useAutomationRule(ruleId);
  const [isFetching, setIsFetching] = useState(false);
  const {
    tempState,
    setTempState,
    errors,
    setErrors
  } = useRuleState();
  const maxTriggerId = useRef(0);
  const maxActionId = useRef(0);
  let t1;
  let t2;
  if ($[0] !== rule || $[1] !== setTempState) {
    t1 = () => {
      if (rule) {
        setTempState(prev => ({
          ...prev,
          ...rule
        }));
        if (rule.actions.length !== 0) {
          maxActionId.current = Math.max(...rule.actions.map(_temp));
        }
      }
    };
    t2 = [rule, setTempState];
    $[0] = rule;
    $[1] = setTempState;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== clearSelectedRule || $[5] !== mutate || $[6] !== mutateAvailableTriggers || $[7] !== mutateRules) {
    t3 = async rule_0 => {
      await mutate(data => ({
        ...data,
        ...rule_0
      }));
      await mutateRules();
      await mutateAvailableTriggers();
      clearSelectedRule();
    };
    $[4] = clearSelectedRule;
    $[5] = mutate;
    $[6] = mutateAvailableTriggers;
    $[7] = mutateRules;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const afterSave = t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ArrowIonicLeftIcon className="group-hover:fill-brand-primary main-transition-colors lg:hidden" />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("dashboard.funnel.automation_rules.back");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <span className="hidden lg:inline">{t5}</span>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== clearSelectedRule || $[15] !== isFetching || $[16] !== t6) {
    t7 = <NeutralButton disabled={isFetching} className="w-fit" onClick={clearSelectedRule}>{t4}{t6}</NeutralButton>;
    $[14] = clearSelectedRule;
    $[15] = isFetching;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== afterSave || $[19] !== isFetching || $[20] !== ruleId || $[21] !== setErrors || $[22] !== tempState) {
    t8 = <div className="flex justify-end"><RuleSave afterSave={afterSave} isFetching={isFetching} setIsFetching={setIsFetching} rule={tempState} ruleId={ruleId} setErrors={setErrors} /></div>;
    $[18] = afterSave;
    $[19] = isFetching;
    $[20] = ruleId;
    $[21] = setErrors;
    $[22] = tempState;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t7 || $[25] !== t8) {
    t9 = <div className="grid grid-flow-col-dense grid-cols-2">{t7}{t8}</div>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const t10 = !rule;
  const t11 = rule?.triggers;
  let t12;
  if ($[27] !== availableTriggers || $[28] !== customAddTriggerHandler || $[29] !== errors || $[30] !== getRelatedAndUnrelatedTriggersData || $[31] !== isFetching || $[32] !== noRelatedMessage || $[33] !== ruleId || $[34] !== setTempState || $[35] !== t10 || $[36] !== t11 || $[37] !== tempState) {
    t12 = <SpecificTriggerRule ruleId={ruleId} isFetching={isFetching} availableTriggers={availableTriggers} tempState={tempState} setTempState={setTempState} errors={errors} maxTriggerId={maxTriggerId} maxActionId={maxActionId} isPreFetching={t10} savedTriggers={t11} getRelatedAndUnrelatedTriggersData={getRelatedAndUnrelatedTriggersData} customAddTriggerHandler={customAddTriggerHandler} noRelatedMessage={noRelatedMessage} />;
    $[27] = availableTriggers;
    $[28] = customAddTriggerHandler;
    $[29] = errors;
    $[30] = getRelatedAndUnrelatedTriggersData;
    $[31] = isFetching;
    $[32] = noRelatedMessage;
    $[33] = ruleId;
    $[34] = setTempState;
    $[35] = t10;
    $[36] = t11;
    $[37] = tempState;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t12 || $[40] !== t9) {
    t13 = <div className="flex flex-col gap-5 px-6 py-4 lg:px-8">{t9}{t12}</div>;
    $[39] = t12;
    $[40] = t9;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  return t13;
};
export default SpecificTriggerRuleEdit;
function _temp(el) {
  return el.id;
}